import mixpanel from 'mixpanel-browser';
import { createAction, handleActions } from 'redux-actions';
import Agent from '../../api/Agent';
import { handleError } from '../user';
import mixpanelConstants from '../../constants/mixpanel';
import { getEMRString } from './organization';
import { ORG_STATUS } from '../../constants/orgStatus';
import { HTTPStatusCodes } from '../../constants/httpStatusCodes';

import { isFeatureActive, getGlobalFeatures, setSelectedRateIncrease } from '../features';
import testFeatures from '../../constants/testFeatures';

export const setorgDetail = createAction('SET_ORG_DETAIL');
export const setLocDetail = createAction('SET_LOC_DETAIL');
export const setLocName = createAction('SET_LOC_NAME');
export const setLocAddress = createAction('SET_LOC_ADDRESS');
export const setLocCity = createAction('SET_LOC_CITY');
export const setLocState = createAction('SET_LOC_STATE');
export const setLocZipcode = createAction('SET_LOC_ZIPCODE');
export const setLocPhone = createAction('SET_LOC_PHONE');
export const setRequirements = createAction('SET_REQUIREMENT');
export const setSearchString = createAction('SET_SEARCH_STRING');
export const setOrgRequirement = createAction('SET_ORG_REQ');
export const setOrgId = createAction('SET_ORG_ID');
export const setLocId = createAction('SET_LOC_ID');
export const createDepartment = createAction('CREATE_DEPARTMENT');
export const setDeptId = createAction('SET_DEPT_ID');
export const setAddState = createAction('SET_ADD_STATE');
export const setConnctrnReq = createAction('SET_CON_REQ');
export const setLocUsers = createAction('SET_LOC_USERS');
export const setLocRequirement = createAction('SET_LOC_REQ');
export const setDeptRequirement = createAction('SET_DEPT_REQ');
export const setOrgStatusId = createAction('SET_ORG_STATUS_ID');
export const setOrgStatusTypes = createAction('SET_ORG_STATUS_TYPES');
export const setShiftCancellationBillableHours = createAction('SET_SHIFT_CANCELLATION_BILLABLE_HOURS');
export const setDefaultPRNOnlyDays = createAction('SET_DEFAULT_PRN_ONLY_DAYS');
export const setCFGIncentive = createAction('SET_CFG_INCENTIVE');

export const setIsTestOrg = createAction('SET_IS_TEST_ORG');
export const setName = createAction('SET_NAME');
export const setTimezone = createAction('SET_TIMEZONE');
export const setCity = createAction('SET_CITY');
export const setState = createAction('SET_STATE');
export const setLogo = createAction('SET_LOGO');
export const setCutoff = createAction('SET_CUTOFF');
export const setTypeArray = createAction('SET_TYPE_ARRAY');
export const setLoaderDisplay = createAction('SET_LOADER_DISPLAY');
export const setImgMsgDisplay = createAction('SET_IMG_MSG_DISPLAY');
export const setDeptName = createAction('SET_DEPT_NAME');
export const setSearchUserList = createAction('SET_USERS_LIST');
export const setUserSearchString = createAction('SET_USERS_SEARCH_TEXT');
export const setUserDeptId = createAction('SET_USER_DEPT_ID');
export const setUserEmpType = createAction('SET_USER_EMP_TYPE');
export const setFeatureList = createAction('SET_FEATURELIST');
export const setPageNumber = createAction('SET_PAGE_NUMBER');
export const setblueloadDisplay = createAction('SET_BLUE_LOAD_DISPLAY');
export const setFeatureId = createAction('SET_FEATURE_ID');
export const setFeatureStatus = createAction('SET_FEATURE_STATUS');
export const setOrgUpcomingShifts = createAction('SET_ORG_UPCOMING_SHIFTS');

export const clearLocName = createAction('CLEAR_LOC_NAME');
export const clearLocAdd = createAction('CLEAR_ADD');
export const clearLocState = createAction('CLEAR_STATE');
export const clearLocCity = createAction('CLEAR_CITY');
export const clearLocZip = createAction('CLEAR_ZIP');
export const clearLocPhone = createAction('CLEAR_PHONE');
export const clearLocTimezone = createAction('CLEAR_LOC_TIMEZONE');
export const clearDeptName = createAction('CLEAR_DEPT_NAME');
export const clearUserDeptId = createAction('CLEAR_USER_DEPT_ID');
export const clearUserEmpType = createAction('CLEAR_USER_EMP_TYPE');

export const setSuperPrefForOrganization = createAction('SET_SUPER_PREF_FOR_ORG');
export const setIsFetching = createAction('SET_IS_FETCHING');

export const setOrgEMR = createAction('SET_ORG_EMR');
export const setLocEMR = createAction('SET_LOC_EMR');
export const clearOrgEMR = createAction('CLEAR_ORG_EMR');
export const clearLocEMR = createAction('CLEAR_LOC_EMR');
export const setIsSavingLocationData = createAction('SET_IS_SAVING_FAC_DETAILS');
export const setUnsavedChangesFacilityDetails = createAction('SET_UNSAVED_CHANGES_FAC_DETAILS');
export const setIsFetchingLocationData = createAction('SET_IS_FETCHING_LOCATION_DATA');

export const setIsRTEUploadingFile = createAction('SET_IS_RTE_UPLOADING_FILE');

export const setAdditionalReqDetails = createAction('SET_ADDITIONAL_REQ_DETAILS');
export const setIsFetchingReqDetails = createAction('SET_IS_FETCHING_REQ_DETAILS');
export const setIsOpenAdditionalReqModal = createAction('SET_IS_OPEN_ADDITIONAL_REQ_MODAL');
export const setIsOpenMultiOptionReqModal = createAction('SET_IS_OPEN_MULTI_OPTION_REQ_MODAL');
export const setIsOpenAdditionalReqOrgModal = createAction('SET_IS_OPEN_ADDITIONAL_REQ_ORG_MODAL');
export const setLocRequiredFields = createAction('SET_LOC_REQUIRED_FIELDS');
export const setIsEditAdditionalReq = createAction('SET_IS_EDIT_ADDITIONAL_REQ');
export const setIsEditMultiOptionReq = createAction('SET_IS_EDIT_MULTI_OPTION_REQ');
export const setIsEditAdditionalReqOrg = createAction('SET_IS_EDIT_ADDITIONAL_REQ_ORG');
export const setIsFetchingLocReq = createAction('SET_IS_FETCHING_LOC_REQ');

export const setUserPool = createAction('ORGANIZATION/SET_USER_POOL');
export const setZipcodeError = createAction('SET_ZIPCODE_ERROR');

const initialState = {
	additionalRequirementDetails: {},
	addState: '',
	care_setting: '',
	connectrnReq: [],
	defaultPRNOnlyDays: '',
	dept_id: 0,
	dept_name: '',
	deptRequirements: [],
	emrList: [],
	feature_id: '',
	feature_list: [],
	feature_status: false,
	img_msg: 'none',
	isEditAdditionalReq: false,
	isEditAdditionalReqOrg: false,
	isEditMultiOptionReq: false,
	isFetching: false,
	isFetchingLocationData: false,
	isFetchingLocReq: false,
	isFetchingRequirementDetails: false,
	isOpenAdditionalReqModal: false,
	isOpenAdditionalReqOrgModal: false,
	isOpenMultiOptionReqModal: false,
	isRTEUploadingFile: false,
	isSavingFacilityDetails: false,
	loaddisplay: 'none',
	loader_display: 'none',
	loc_emr: [],
	loc_id: 0,
	loc_timezone_id: '1',
	locAddress: '',
	locCity: '',
	locDetail: {},
	locName: '',
	locPhone: '',
	locRequiredFields: [],
	locRequirements: [],
	locState: '',
	locUsers: [],
	locZipcode: '',
	org_bonus_amount: null,
	org_city: '',
	org_cutoff: 0,
	org_emr: [],
	org_id: 0,
	org_logo: '',
	org_name: '',
	org_state: '',
	org_typeArray: [],
	orgDetail: {},
	orgRequirements: [],
	orgStatusId: 0,
	page_no: 1,
	reqSearchList: [],
	search_text: '',
	searchUsersList: [],
	shift_cancellation_billable_hours: 4,
	superPrefForOrg: [],
	timezone_id: '1',
	type_id: '0',
	unsavedChangesFacilityDetails: false,
	user_dept_id: 0,
	user_emp_type: '',
	user_search_text: '',
	userPool: 'crn',
	zipCodeError: false
};

export default handleActions(
	{
		CLEAR_ADD: (state) => ({ ...state, locAddress: initialState.locAddress }),
		CLEAR_CITY: (state) => ({ ...state, locCity: initialState.locCity }),
		CLEAR_DEPT_NAME: (state) => ({ ...state, dept_name: initialState.dept_name }),
		CLEAR_LOC_NAME: (state) => ({ ...state, locName: initialState.locName }),
		CLEAR_LOC_TIMEZONE: (state) => ({ ...state, loc_timezone_id: initialState.loc_timezone_id }),
		CLEAR_ORG_EMR: (state) => ({ ...state, org_emr: initialState.org_emr }),
		CLEAR_ORG_EMR: (state) => ({ ...state, org_emr: initialState.org_emr }),
		CLEAR_PHONE: (state) => ({ ...state, locPhone: initialState.locPhone }),
		CLEAR_STATE: (state) => ({ ...state, locState: initialState.locState }),
		CLEAR_USER_DEPT_ID: (state) => ({ ...state, user_dept_id: initialState.user_dept_id }),
		CLEAR_USER_EMP_TYPE: (state) => ({ ...state, user_emp_type: initialState.user_emp_type }),
		CLEAR_ZIP: (state) => ({ ...state, locZipcode: initialState.locZipcode }),
		CREATE_DEPARTMENT: (state, action) => ({ ...state, department: action.payload }),
		'ORGANIZATION/SET_USER_POOL': (state, action) => ({ ...state, userPool: action.payload }),
		SET_ADD_STATE: (state, action) => ({ ...state, addState: action.payload }),
		SET_ADDITIONAL_REQ_DETAILS: (state, action) => ({ ...state, additionalRequirementDetails: action.payload }),
		SET_BLUE_LOAD_DISPLAY: (state, action) => ({ ...state, loaddisplay: action.payload }),
		SET_CFG_INCENTIVE: (state, action) => ({
			...state,
			org_bonus_amount: action.payload
		}),
		SET_CITY: (state, action) => ({ ...state, org_city: action.payload }),
		SET_CON_REQ: (state, action) => ({ ...state, connectrnReq: action.payload }),
		SET_CUTOFF: (state, action) => ({ ...state, org_cutoff: action.payload }),
		SET_DEFAULT_PRN_ONLY_DAYS: (state, action) => ({ ...state, defaultPRNOnlyDays: action.payload }),
		SET_DEPT_ID: (state, action) => ({ ...state, dept_id: action.payload }),
		SET_DEPT_NAME: (state, action) => ({ ...state, dept_name: action.payload }),
		SET_DEPT_REQ: (state, action) => ({ ...state, deptRequirements: action.payload }),
		SET_FEATURE_ID: (state, action) => ({ ...state, feature_id: action.payload }),
		SET_FEATURE_STATUS: (state, action) => ({ ...state, feature_status: action.payload }),
		SET_FEATURELIST: (state, action) => ({ ...state, feature_list: action.payload }),
		SET_IMG_MSG_DISPLAY: (state, action) => ({ ...state, img_msg: action.payload }),
		SET_IS_EDIT_ADDITIONAL_REQ: (state, action) => ({ ...state, isEditAdditionalReq: action.payload }),
		SET_IS_EDIT_ADDITIONAL_REQ: (state, action) => ({ ...state, isEditAdditionalReq: action.payload }),
		SET_IS_EDIT_ADDITIONAL_REQ_ORG: (state, action) => ({ ...state, isEditAdditionalReqOrg: action.payload }),
		SET_IS_EDIT_ADDITIONAL_REQ_ORG: (state, action) => ({ ...state, isEditAdditionalReqOrg: action.payload }),
		SET_IS_EDIT_MULTI_OPTION_REQ: (state, action) => ({ ...state, isEditMultiOptionReq: action.payload }),
		SET_IS_EDIT_MULTI_OPTION_REQ: (state, action) => ({ ...state, isEditMultiOptionReq: action.payload }),
		SET_IS_FETCHING: (state, action) => ({ ...state, isFetching: action.payload }),
		SET_IS_FETCHING: (state, action) => ({ ...state, isFetching: action.payload }),
		SET_IS_FETCHING_LOC_REQ: (state, action) => ({ ...state, isFetchingLocReq: action.payload }),
		SET_IS_FETCHING_LOC_REQ: (state, action) => ({ ...state, isFetchingLocReq: action.payload }),
		SET_IS_FETCHING_LOCATION_DATA: (state, action) => ({ ...state, isFetchingLocationData: action.payload }),
		SET_IS_FETCHING_LOCATION_DATA: (state, action) => ({ ...state, isFetchingLocationData: action.payload }),
		SET_IS_FETCHING_REQ_DETAILS: (state, action) => ({ ...state, isFetchingRequirementDetails: action.payload }),
		SET_IS_FETCHING_REQ_DETAILS: (state, action) => ({ ...state, isFetchingRequirementDetails: action.payload }),
		SET_IS_OPEN_ADDITIONAL_REQ_MODAL: (state, action) => ({ ...state, isOpenAdditionalReqModal: action.payload }),
		SET_IS_OPEN_ADDITIONAL_REQ_MODAL: (state, action) => ({ ...state, isOpenAdditionalReqModal: action.payload }),
		SET_IS_OPEN_ADDITIONAL_REQ_ORG_MODAL: (state, action) => ({
			...state,
			isOpenAdditionalReqOrgModal: action.payload
		}),
		SET_IS_OPEN_ADDITIONAL_REQ_ORG_MODAL: (state, action) => ({
			...state,
			isOpenAdditionalReqOrgModal: action.payload
		}),
		SET_IS_OPEN_MULTI_OPTION_REQ_MODAL: (state, action) => ({ ...state, isOpenMultiOptionReqModal: action.payload }),
		SET_IS_OPEN_MULTI_OPTION_REQ_MODAL: (state, action) => ({ ...state, isOpenMultiOptionReqModal: action.payload }),
		SET_IS_RTE_UPLOADING_FILE: (state, action) => ({ ...state, isRTEUploadingFile: action.payload }),
		SET_IS_RTE_UPLOADING_FILE: (state, action) => ({ ...state, isRTEUploadingFile: action.payload }),
		SET_IS_SAVING_FAC_DETAILS: (state, action) => ({ ...state, isSavingFacilityDetails: action.payload }),
		SET_IS_TEST_ORG: (state, action) => ({ ...state, is_test_org: action.payload }),
		SET_LOADER_DISPLAY: (state, action) => ({ ...state, loader_display: action.payload }),
		SET_LOC_ADDRESS: (state, action) => ({ ...state, locAddress: action.payload }),
		SET_LOC_CITY: (state, action) => ({ ...state, locCity: action.payload }),
		SET_LOC_DETAIL: (state, action) => ({ ...state, locDetail: action.payload }),
		SET_LOC_EMR: (state, action) => ({ ...state, loc_emr: action.payload }),
		SET_LOC_ID: (state, action) => ({ ...state, loc_id: action.payload }),
		SET_LOC_NAME: (state, action) => ({ ...state, locName: action.payload }),
		SET_LOC_PHONE: (state, action) => ({ ...state, locPhone: action.payload }),
		SET_LOC_REQ: (state, action) => ({ ...state, locRequirements: action.payload }),
		SET_LOC_REQUIRED_FIELDS: (state, action) => ({ ...state, locRequiredFields: action.payload }),
		SET_LOC_STATE: (state, action) => ({ ...state, locState: action.payload }),
		SET_LOC_TIMEZONE: (state, action) => ({ ...state, loc_timezone_id: action.payload }),
		SET_LOC_USERS: (state, action) => ({ ...state, locUsers: action.payload }),
		SET_LOC_ZIPCODE: (state, action) => ({ ...state, locZipcode: action.payload }),
		SET_LOGO: (state, action) => ({ ...state, org_logo: action.payload }),
		SET_NAME: (state, action) => ({ ...state, org_name: action.payload }),
		SET_ORG_DETAIL: (state, action) => ({ ...state, orgDetail: action.payload }),
		SET_ORG_EMR: (state, action) => ({ ...state, org_emr: action.payload }),
		SET_ORG_ID: (state, action) => ({ ...state, org_id: action.payload }),
		SET_ORG_REQ: (state, action) => ({ ...state, orgRequirements: action.payload }),
		SET_ORG_STATUS_ID: (state, action) => ({ ...state, orgStatusId: action.payload }),
		SET_ORG_STATUS_TYPES: (state, action) => ({ ...state, orgStatusTypes: action.payload }),
		SET_ORG_UPCOMING_SHIFTS: (state, action) => ({ ...state, orgUpcomingShifts: action.payload }),
		SET_PAGE_NUMBER: (state, action) => ({ ...state, page_no: action.payload }),
		SET_REQUIREMENT: (state, action) => ({ ...state, reqSearchList: action.payload }),
		SET_SEARCH_STRING: (state, action) => ({ ...state, search_text: action.payload }),
		SET_SHIFT_CANCELLATION_BILLABLE_HOURS: (state, action) => ({
			...state,
			shift_cancellation_billable_hours: action.payload
		}),
		SET_STATE: (state, action) => ({ ...state, org_state: action.payload }),
		SET_SUPER_PREF_FOR_ORG: (state, action) => ({ ...state, superPrefForOrg: action.payload }),
		SET_TIMEZONE: (state, action) => ({ ...state, timezone_id: action.payload }),
		SET_TYPE: (state, action) => ({ ...state, type_id: action.payload }),
		SET_TYPE_ARRAY: (state, action) => ({ ...state, org_typeArray: action.payload }),
		SET_UNSAVED_CHANGES_FAC_DETAILS: (state, action) => ({ ...state, unsavedChangesFacilityDetails: action.payload }),
		SET_USER_DEPT_ID: (state, action) => ({ ...state, user_dept_id: action.payload }),
		SET_USER_EMP_TYPE: (state, action) => ({ ...state, user_emp_type: action.payload }),
		SET_USERS_LIST: (state, action) => ({ ...state, searchUsersList: action.payload }),
		SET_USERS_SEARCH_TEXT: (state, action) => ({ ...state, user_search_text: action.payload }),
		SET_ZIPCODE_ERROR: (state, action) => ({ ...state, zipCodeError: action.payload })
	},
	initialState
);

export function mapEMRToOptions(emrs) {
	return emrs.map((emr) => ({
		label: emr.name,
		value: emr.id
	}));
}

export const clearformValues = () =>
	function (dispatch) {
		dispatch(clearLocName());
		dispatch(clearLocAdd());
		dispatch(clearLocState());
		dispatch(clearLocCity());
		dispatch(clearLocZip());
		dispatch(clearLocTimezone());
		dispatch(clearLocPhone());
		dispatch(clearOrgEMR());
		dispatch(clearLocEMR());
		dispatch(setZipcodeError(false));
	};

export const resetLocEMR = () => (dispatch, getState) => {
	const { orgdetails } = getState();

	const emrs =
		orgdetails.orgDetail && orgdetails.orgDetail.emr
			? orgdetails.orgDetail.emr.filter((emr) => emr.enabled).map((emr) => emr.id)
			: [];
	dispatch(setOrgEMR(emrs));
	dispatch(setLocEMR(emrs));
};

export const clearAddUserValues = () =>
	function (dispatch) {
		dispatch(clearUserDeptId());
		dispatch(clearUserEmpType());
	};

export const getOrgByid = (id, locId = null) =>
	function (dispatch) {
		dispatch(setIsFetching(true));

		return Agent.getOrgById(id).then((response) => {
			if (response.ok) {
				dispatch(setorgDetail(response.data));
				dispatch(setIsTestOrg(response.data.is_test_org));
				dispatch(setName(response.data.title));
				dispatch(setTimezone(response.data.timezone_id));
				dispatch(setState(response.data.state));
				dispatch(setCity(response.data.city));
				dispatch(setLogo(response.data.storage_location));
				dispatch(setCutoff(`${response.data.shift_cutoff_hours}`));
				dispatch(setOrgStatusId(response.data.organization_status));
				dispatch(setShiftCancellationBillableHours(response.data.shift_cancellation_billable_hours));
				dispatch(setCFGIncentive(response.data.org_bonus_amount));
				dispatch(
					setDefaultPRNOnlyDays(response.data.default_PRN_days === null ? '' : `${response.data.default_PRN_days}`)
				);
				if (response.data.emr) {
					const emrs = response.data.emr.filter((emr) => emr.enabled).map((emr) => emr.id) || [];

					dispatch(setOrgEMR(emrs));
					dispatch(setLocEMR(emrs));
				}

				if (locId != null && locId != 0) {
					dispatch(getLocbyid(locId));
					dispatch(getLocUser(locId));
					dispatch(setLocId(locId));
					dispatch(getLocRequirement(locId));
					dispatch(getSearchRequirementList());
				} else if (response.data.locations[0] !== null && response.data.locations[0] !== undefined) {
					const locationId = response.data.locations[0].location_id;
					dispatch(getLocbyid(locationId));
					dispatch(getLocUser(locationId));
					dispatch(setLocId(locationId));
					dispatch(getLocRequirement(locationId));
					dispatch(getSearchRequirementList());
				}
				dispatch(setIsFetching(false));
			} else {
				dispatch(handleError(response));
				dispatch(setIsFetching(false));
			}
		});
	};

export const getLocbyid = (id) =>
	function (dispatch) {
		dispatch(setIsFetchingLocationData(true));

		Agent.getLocById(id).then((response) => {
			if (response.ok) {
				dispatch(setLocDetail(response.data));
				dispatch(setLocName(response.data.location_name));
				dispatch(setLocAddress(response.data.address));
				dispatch(setLocCity(response.data.city));
				dispatch(setLocState(response.data.state));
				dispatch(setLocZipcode(response.data.zip));
				dispatch(setLocPhone(response.data.phone_number));
				dispatch(setSelectedRateIncrease(response.data.shift_bonus_level_cap));

				if (response.data.emr) {
					const emrs = response.data.emr.filter((emr) => emr.enabled).map((emr) => emr.id) || [];
					dispatch(setLocEMR(emrs));
				}

				dispatch(setIsFetchingLocationData(false));
				//  dispatch(setRequirements(response.data.city))
			} else {
				dispatch(handleError(response));

				dispatch(setIsFetchingLocationData(false));
			}
		});
	};

export const createLocation = (requirements, onError = (f) => f, onSuccess) =>
	function (dispatch, getState) {
		const {
			locName,
			locAddress,
			locCity,
			locState,
			locZipcode,
			locPhone,
			loc_timezone_id,
			org_id,
			loc_id,
			loc_emr,
			org_name
		} = getState().orgdetails;
		// location_id,organization_id,location_name,address,city,state,zip,phone_number,requirements=[]

		// const {emrList} = getState().adminOrganization
		// console.log('emr', loc_emr)

		// const emrValues = mapOptionsToEMR(emrList.map(emr => ({
		// 	...emr,
		// 	enabled: loc_emr.includes(emr.value)
		// })))

		const emrValues = (loc_emr || []).map((emr) => ({
			id: emr
		}));

		Agent.createLocation(
			loc_id,
			parseInt(org_id),
			locName,
			locAddress,
			locCity,
			locState,
			locZipcode,
			locPhone,
			parseInt(loc_timezone_id),
			requirements,
			emrValues
		).then((response) => {
			if (response.ok) {
				// dispatch(setLocDetail(response.data))
				dispatch(getOrgByid(org_id));
				if (loc_id !== 0) {
					dispatch(getLocbyid(loc_id));
					dispatch(getLocRequirement(loc_id));
				}
				const event = loc_id === 0 ? mixpanelConstants.ADD_NEW_LOCATION : mixpanelConstants.EDIT_LOCATION;

				mixpanel.track(event, {
					address: locAddress,
					city: locCity,
					emr: getEMRString(emrValues),
					name: locName,
					organization_name: org_name,
					state: locState
				});
				onSuccess(response.data);
			} else {
				if (response.status === 403) {
					onError(response.data);
				}

				if (response.status === 422) {
					dispatch(setZipcodeError(true));
					return;
				}

				dispatch(handleError(response));
			}
		});
	};

export const getSearchRequirementList = (isCompanionReq) =>
	function (dispatch, getState) {
		let { search_text, org_id, loc_id, dept_id, addState } = getState().orgdetails;

		if (search_text == undefined) {
			search_text = undefined;
		}
		if (loc_id === 0) {
			loc_id = 'NA';
		}
		if (dept_id === 0) {
			dept_id = 'NA';
		}

		Agent.getAllRequirements(search_text, org_id, loc_id, dept_id, addState, isCompanionReq).then((response) => {
			if (response.ok) {
				dispatch(setRequirements(response.data));
			} else {
			}
		});
	};

export const getOrgReq = (id) =>
	function (dispatch) {
		Agent.getOrgRequirements(id).then((response) => {
			if (response.ok) {
				dispatch(setOrgRequirement(response.data));
			} else {
			}
		});
	};
export const deleteLoc = (locid) =>
	function (dispatch, getState) {
		const { org_id } = getState().orgdetails;
		Agent.deleteLocation(locid).then((response) => {
			if (response.ok) {
				dispatch(getOrgByid(org_id));
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const getDetailCSType = () =>
	function (dispatch) {
		Agent.CSType().then((response) => {
			if (response.ok) {
				dispatch(setTypeArray(response.data));
			} else {
			}
		});
	};

export const uploadLogo = (file) =>
	function (dispatch) {
		if (file) {
			dispatch(setLoaderDisplay('block'));
			Agent.commonFileUpload(file).then((response) => {
				if (response.ok) {
					dispatch(setLogo(response.data.path));
					dispatch(setImgMsgDisplay('block'));
					dispatch(setLoaderDisplay('none'));
				} else {
					dispatch(setLoaderDisplay('none'));
					alert('Failed to upload file. Please check you file type and file size.');
				}
			});
		} else {
			dispatch(setLoaderDisplay('none'));
		}
	};

export const createOrganization = () =>
	function (dispatch, getState) {
		const {
			org_id,
			is_test_org,
			org_bonus_amount,
			org_name,
			timezone_id,
			org_city,
			org_state,
			org_logo,
			org_cutoff,
			org_emr,
			orgStatusId,
			shift_cancellation_billable_hours,
			defaultPRNOnlyDays
		} = getState().orgdetails;

		const emrValues = (org_emr || []).map((emr) => ({
			id: emr
		}));

		const defaultPRNOnlyDaysValue = defaultPRNOnlyDays === '' ? null : parseInt(defaultPRNOnlyDays);

		// organization_id, title,address,city,state,zip,phone_number,storage_location,organization_type,shift_cutoff_hours
		Agent.createOrganization(
			parseInt(org_id),
			is_test_org,
			org_name,
			org_city,
			org_state,
			org_logo,
			parseInt(timezone_id),
			parseInt(org_cutoff),
			emrValues,
			parseInt(orgStatusId),
			parseInt(shift_cancellation_billable_hours),
			parseFloat(org_bonus_amount),
			defaultPRNOnlyDaysValue
		).then((response) => {
			if (response.ok) {
				dispatch(getOrgByid(response.data.organization_id));
				mixpanel.track(mixpanelConstants.EDIT_ORGANIZATION, {
					city: org_city,
					cutOff: org_cutoff,
					emr: getEMRString(emrValues),
					name: org_name,
					org_bonus_amount: org_bonus_amount,
					organization_id: parseInt(org_id),
					orgStatus: ORG_STATUS[response.data.organization_status],
					state: org_state
				});
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const getConnectrnReq = () =>
	function (dispatch) {
		Agent.getConnectrnRequirement().then((response) => {
			if (response.ok) {
				dispatch(setConnctrnReq(response.data));
			} else {
			}
		});
	};

export const assignOrgReq = (req_id, expiryDateInterval, altReqID) =>
	function (dispatch, getState) {
		const { org_id } = getState().orgdetails;

		Agent.assignReqToOrganization(org_id, req_id, expiryDateInterval, altReqID).then((response) => {
			if (response.ok) {
				dispatch(getOrgReq(org_id));
				dispatch(getOrgByid(org_id));
				dispatch(getSearchRequirementList());
			} else {
				alert(response.data);
				dispatch(handleError(response));
			}
		});
	};

export const updateAssignOrgReq = (req_id, expiryDateInterval, altReqID) =>
	function (dispatch, getState) {
		const { org_id } = getState().orgdetails;

		Agent.updateAssignReqToOrganization(org_id, req_id, expiryDateInterval, altReqID).then((response) => {
			if (response.ok) {
				dispatch(getOrgReq(org_id));
				dispatch(getOrgByid(org_id));
				dispatch(getSearchRequirementList());
			} else {
				alert(response.data);
				dispatch(handleError(response));
			}
		});
	};

export const unassignOrgReq = (req_id) =>
	function (dispatch, getState) {
		const { org_id } = getState().orgdetails;

		Agent.unassignReqToOrganization(org_id, req_id).then((response) => {
			if (response.ok) {
				dispatch(getOrgReq(org_id));
				dispatch(getOrgByid(org_id));
				dispatch(getSearchRequirementList());
			} else {
				alert(response.data);
				dispatch(handleError(response));
			}
		});
	};

export const getLocUser = (loc_id) =>
	function (dispatch) {
		Agent.getLocationUser(loc_id).then((response) => {
			if (response.ok) {
				dispatch(setLocUsers(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const removeOrgUser = (user_id) =>
	function (dispatch, getState) {
		const { loc_id } = getState().orgdetails;

		Agent.removeOrgUser(loc_id, user_id).then((response) => {
			if (response.ok) {
				dispatch(getLocUser(loc_id));
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const getLocRequirement = (loc_id) =>
	function (dispatch, getState) {
		// const {loc_id} = getState().orgdetails
		dispatch(setIsFetchingLocReq(true));

		Agent.getLocationRequirement(loc_id).then((response) => {
			if (response.ok) {
				dispatch(setLocRequirement(response.data));

				const { globalFeatures } = getState().features;

				// fetch location required fields only if the feature toggle is on
				if (isFeatureActive(testFeatures.LOCATION_REQUIREMENT_REQUIRED_FIELDS, globalFeatures)) {
					dispatch(getLocRequiredFields(loc_id));
				} else {
					dispatch(setIsFetchingLocReq(false));
				}
			} else {
				dispatch(setIsFetchingLocReq(false));
				dispatch(handleError(response));
			}
		});
	};

export const getDeptRequirement = (dept_id) =>
	function (dispatch) {
		Agent.getDeptRequirement(dept_id).then((response) => {
			if (response.ok) {
				dispatch(setDeptRequirement(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const assignLocReq = (req_id) =>
	function (dispatch, getState) {
		const { loc_id } = getState().orgdetails;

		Agent.assignReqToLoc(loc_id, req_id).then((response) => {
			if (response.ok) {
				dispatch(getLocRequirement(loc_id));
				// dispatch(getLocbyid(loc_id))
				dispatch(getSearchRequirementList());
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const unassignLocReq = (req_id) =>
	function (dispatch, getState) {
		const { loc_id } = getState().orgdetails;

		Agent.unassignReqToLoc(loc_id, req_id).then((response) => {
			if (response.ok) {
				dispatch(getLocRequirement(loc_id));
				// dispatch(getLocbyid(loc_id))
				dispatch(getSearchRequirementList());
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const assignDeptReq = (req_id) =>
	function (dispatch, getState) {
		const { dept_id } = getState().orgdetails;

		Agent.assignReqToDept(dept_id, req_id).then((response) => {
			if (response.ok) {
				dispatch(getDeptRequirement(dept_id));
				// dispatch(getLocbyid(dept_id))
				dispatch(getSearchRequirementList());
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const unassignDeptReq = (req_id) =>
	function (dispatch, getState) {
		const { dept_id } = getState().orgdetails;

		Agent.unassignReqToDept(dept_id, req_id).then((response) => {
			if (response.ok) {
				dispatch(getDeptRequirement(dept_id));
				dispatch(getSearchRequirementList());
				// dispatch(getLocbyid(loc_id))
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const deleteDepartment = (dept_id) =>
	function (dispatch, getState) {
		const { loc_id } = getState().orgdetails;

		Agent.deleteDept(dept_id).then((response) => {
			if (response.ok) {
				dispatch(getLocbyid(loc_id));
			} else {
				dispatch(handleError(response));
			}
		});
	};
//thunk: async action that dispatches other actions
export const createDept = (departmentData) =>
	function (dispatch) {
		Agent.createDepartment(departmentData).then((response) => {
			if (response.ok) {
				dispatch(setDeptName(response.data.dept_name));
				dispatch(setDeptId(response.data.department_id));
				dispatch(getLocbyid(departmentData.locationId));
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const updateDeptName = (dept_name) =>
	function (dispatch, getState) {
		const { dept_id, loc_id } = getState().orgdetails;

		Agent.UpdateDeptName(dept_id, dept_name).then((response) => {
			if (response.ok) {
				dispatch(getLocbyid(loc_id));
			} else {
			}
		});
	};

export const searchUsers = () =>
	function (dispatch, getState) {
		const { loc_id, user_search_text } = getState().orgdetails;
		Agent.searchUsers(loc_id, user_search_text).then((response) => {
			if (response.ok) {
				dispatch(setSearchUserList(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const addUsertoOrg = (user_list) =>
	function (dispatch, getState) {
		const { org_id, loc_id, user_dept_id, user_emp_type, userPool } = getState().orgdetails;

		const { globalFeatures } = getState().features;
		const nursePoolType = !isFeatureActive(testFeatures.ORGANIZATION_PRN_POOL, globalFeatures) ? null : userPool;

		Agent.addUserToOrg(parseInt(org_id), loc_id, parseInt(user_dept_id), user_emp_type, user_list, nursePoolType).then(
			(response) => {
				dispatch(setUserPool('crn'));
				if (response.ok) {
					// dispatch(setSearchUserList(response.data))
					dispatch(getLocUser(loc_id));
				} else {
					dispatch(handleError(response));
					alert('Something went wrong. Please refresh your page and try again.');
				}
			}
		);
	};

export const getOrgFeatures = (organizationId = null) =>
	function (dispatch, getState) {
		let orgId = '';
		if (organizationId) {
			orgId = organizationId;
		} else {
			const { org_id } = getState().orgdetails;
			const { organization_id } = getState().supervisordashboard.organizations;
			orgId = org_id || organization_id;
		}
		Agent.getOrgFeatures(parseInt(orgId)).then((response) => {
			if (response.ok) {
				dispatch(setFeatureList(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const getOrgFeaturesById = (orgId) =>
	function (dispatch) {
		Agent.getOrgFeatures(parseInt(orgId)).then((response) => {
			if (response.ok) {
				dispatch(setFeatureList(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const pageNumber = (pageNo) =>
	function (dispatch) {
		// const {search_string,sort,sortorder} = getState().adminOrganization
		dispatch(setPageNumber(pageNo));
	};

export const updateFeatureStatus = () =>
	function (dispatch, getState) {
		const { org_id, feature_id, feature_status } = getState().orgdetails;

		Agent.updateFeatureStatus(parseInt(org_id), feature_id, feature_status).then((response) => {
			if (response.ok) {
				dispatch(getOrgFeatures());
			} else {
				const r = confirm(response.data);
				if (r == true) {
					dispatch(getOrgFeatures());
				}
			}
		});
	};

export const getSuperPrefForOrganization = (orgId) =>
	function (dispatch) {
		Agent.getSuperPrefForOrganization(orgId).then((response) => {
			if (response.ok) {
				// console.log('response: ', JSON.stringify(response.data))
				// Adding one extra department to handle location row.
				const LocPrefs = response.data;

				const tempDept = {};
				if (LocPrefs && LocPrefs.length > 0) {
					for (let pIdx = 0; pIdx < LocPrefs.length; pIdx++) {
						LocPrefs[pIdx].departments = [tempDept, ...LocPrefs[pIdx].departments];
						LocPrefs[pIdx].collapsed = true;
					}
				}
				dispatch(setSuperPrefForOrganization(LocPrefs));
			} else {
			}
		});
	};

export const saveSuperPrefForOrganization = (orgId, userPref) =>
	function (dispatch) {
		Agent.saveSuperPrefForOrganization(orgId, userPref).then((response) => {
			if (response.ok) {
				// console.log("saveSuperPrefForOrganization: " + JSON.stringify(response))
				dispatch(setSuperPrefForOrganization(userPref));
			}
		});
	};

export const updateFacilityDetails = (locId, locDetailsFormData) =>
	function (dispatch, getState) {
		const { org_id } = getState().orgdetails;
		const emrFormatted = locDetailsFormData.emrs?.map((emr) => emr.value);

		const data = {
			about_facility: locDetailsFormData.aboutFacility,
			break_policy: locDetailsFormData.breakPolicy,
			checkin_checkout_process: locDetailsFormData.checkinCheckoutProcess,
			contact_person_on_arrival: locDetailsFormData.contactPersonOnArrival,
			custom_geofence: locDetailsFormData.customGeoCoords,
			emr_ids: emrFormatted,
			is_orientation_required: locDetailsFormData.isOrientationRequired,
			no_of_beds: parseInt(locDetailsFormData.noOfBeds),
			nurse_to_patient_ratio: locDetailsFormData.nurseToPatientRatio,
			orientation_info: locDetailsFormData.orientationInfo,
			post_arrival_info: locDetailsFormData.postArrivalInfo,
			pre_arrival_info: locDetailsFormData.preArrivalInfo,
			supervisor_break_policy: locDetailsFormData.supervisorBreakPolicy,
			time_to_arrive_prior_to_first_shift: parseInt(locDetailsFormData.timeToArrivePriorToFirstShift)
		};

		dispatch(setIsSavingLocationData(true));

		Agent.updateLocationDetails(locId, data).then((response) => {
			dispatch(setIsSavingLocationData(false));

			if (response.ok) {
				dispatch(getOrgByid(org_id, locId));
				dispatch(setUnsavedChangesFacilityDetails(false));

				mixpanel.track(mixpanelConstants.SAVE_FACILITY_DETAILS_INFO, {
					checkinCheckoutProcess: locDetailsFormData.checkinCheckoutProcess,
					contactPersonOnArrival: locDetailsFormData.contactPersonOnArrival,
					emrIds: locDetailsFormData.emrs?.map((emr) => emr.name),
					isOrientationRequired: locDetailsFormData.isOrientationRequired,
					locAddress: getState().orgdetails.locAddress,
					locCity: getState().orgdetails.locCity,
					locName: getState().orgdetails.locName,
					locState: getState().orgdetails.locState,
					locZipcode: getState().orgdetails.locZipcode,
					noOfBeds: parseInt(locDetailsFormData.noOfBeds),
					nurseToPatientRatio: locDetailsFormData.nurseToPatientRatio,
					orgName: getState().orgdetails.org_name,
					timeToArrivePriorToFirstShift: parseInt(locDetailsFormData.timeToArrivePriorToFirstShift)
				});
				alert('The facility details have been saved successfully');
			} else if (response.status === HTTPStatusCodes.FORBIDDEN) {
				dispatch(setUnsavedChangesFacilityDetails(false));
				alert(
					response.data
						? `Error: ${response.data}Please reload the page now.`
						: 'Error: Forbidden to update the facility details. Please reload the page now.'
				);
			} else {
				dispatch(handleError(response));
				alert(response.data ? `Error: ${response.data}` : 'Error saving facility details data.');
			}
		});
	};

export const getAdditionalRequirementDetails = (reqID, onComplete) =>
	function (dispatch) {
		dispatch(setIsFetchingReqDetails(true));
		Agent.getRequirementById(reqID).then((response) => {
			dispatch(setIsFetchingReqDetails(false));
			if (response.ok) {
				const reqDetails = response.data;

				dispatch(setAdditionalReqDetails(reqDetails));

				onComplete?.(reqDetails);
			} else {
				dispatch(setAdditionalReqDetails({}));
				alert('Error fetching requirement details.');
				dispatch(handleError(response));
			}
		});
	};

export const getAdditionalRequirementDetailsForOrg = (reqID, OrgID) =>
	function (dispatch, getState) {
		dispatch(setIsFetchingReqDetails(true));
		const { locRequirements, locRequiredFields } = getState().orgdetails;
		Agent.getRequirementByIdAndOrg(reqID, OrgID).then((response) => {
			dispatch(setIsFetchingReqDetails(false));
			if (response.ok) {
				const reqDetails = response.data;

				reqDetails.fields.forEach((field) => {
					if (locRequirements.find((lReq) => lReq.requirement_id === reqDetails.id) && locRequiredFields !== null) {
						field.required = !!locRequiredFields.find((locFieldId) => locFieldId === field.id);
					} else {
						field.required = false;
					}
				});

				dispatch(setAdditionalReqDetails(reqDetails));
			} else {
				dispatch(setAdditionalReqDetails({}));
				alert('Error fetching requirement details.');
				dispatch(handleError(response));
			}
		});
	};

// addAdditionalReqWithRequiredFields add additional requirements along with required fields, if any, for a location
export const addAdditionalLocReqWithFields = (reqID, fieldsList) =>
	function (dispatch, getState) {
		const { loc_id } = getState().orgdetails;

		const reqFieldsData = fieldsList.map((field) => ({
			isDeleted: !field.required,
			reqFieldId: field.id
		}));

		Agent.assignReqWithFieldsToLoc(loc_id, reqID, reqFieldsData).then((response) => {
			if (response.ok) {
				dispatch(getLocRequirement(loc_id));
				dispatch(getSearchRequirementList());

				alert('Additional Requirement added successfully');
				dispatch(setAdditionalReqDetails({}));
			} else {
				dispatch(handleError(response));
				alert('Error adding Additional Requirement for the location.');
			}
		});
	};

// This add multi-option requirement fields to a specific location
export const addAdditionalLocMultiReqWithFields = (fieldsData, locationId, onSuccess) =>
	function (dispatch, getState) {
		const { loc_id } = getState().orgdetails;

		Agent.assignMultiReqWithFieldsToLoc(locationId !== undefined ? locationId : loc_id, fieldsData).then((response) => {
			if (response.ok) {
				dispatch(setIsOpenMultiOptionReqModal(false));
				dispatch(setIsEditMultiOptionReq(false));
				dispatch(setAdditionalReqDetails({}));
				onSuccess();
			} else {
				dispatch(handleError(response));
				alert('Error adding Additional Requirement for the location.');
			}
		});
	};

export const addAdditionalLocSingleReqWithFields = (reqID, fieldsList, locationId, onSuccess) =>
	function (dispatch) {
		Agent.assignReqWithFieldsToLoc(locationId, reqID, fieldsList).then((response) => {
			if (response.ok) {
				dispatch(setAdditionalReqDetails({}));
				onSuccess();
			} else {
				dispatch(handleError(response));
				alert('Error adding Additional Requirement for the location.');
			}
		});
	};

export const getLocRequiredFields = (locID) =>
	function (dispatch) {
		Agent.fetchLocRequiredFields(locID).then((response) => {
			dispatch(setIsFetchingLocReq(false));
			if (response.ok) {
				if (response.data.reqFieldIds === null) {
					dispatch(getGlobalFeatures());
					dispatch(setLocRequiredFields([]));
				} else {
					dispatch(setLocRequiredFields(response.data.reqFieldIds));
				}
			}
		});
	};

export const updateAdditionalLocReqWithFields = (reqID, fieldsList) =>
	function (dispatch, getState) {
		const { loc_id } = getState().orgdetails;

		const reqFieldsData = fieldsList.map((field) => ({
			isDeleted: !field.required,
			reqFieldId: field.id
		}));

		Agent.updateReqWithFieldsToLoc(loc_id, reqID, reqFieldsData).then((response) => {
			if (response.ok) {
				dispatch(getLocRequirement(loc_id));
				dispatch(getSearchRequirementList());

				alert('Additional Requirement updated successfully');
				dispatch(setAdditionalReqDetails({}));
			} else {
				dispatch(handleError(response));
				alert('Error updating Additional Requirement for the location.');
			}
		});
	};
